import { Observable, of } from 'rxjs';

export function getKnownIssues(): Observable<any[]> {
     return of([
          {
               id: 1,
               descriptionShown: false,
               isNew: false,
               name: "Tab Bar Ink Line",
               description: `On the Flights view, when rotating the screen from portrait to landscape view 
               (or vice versa) the selected tab blue ink line Table and Calendar views does not fully align 
               with the selected tab.  Selecting the same or other tab corrects the alignment.`
          },
          {
               id: 2,
               descriptionShown: false,
               isNew: false,
               name: "Aircraft Type and Nose Number",
               description: `Aircraft Type, registration and nose number may be missing due to a lag in data 
               retrieval from AA.`
          },
          {
               id: 3,
               descriptionShown: false,
               isNew: false,
               name: "Analyze Totals",
               description: `Flight Totals data and charts may or may not equal to what is show on the 
               user's HI*9.`
          },
          {
               id: 4,
               descriptionShown: false,
               isNew: false,
               name: "Captain OE flight time",
               description: `Upgrade Captains conducting OE (operational experience) flights are inadvertently 
               being logged as Captain instead of First Officer.  This is a known issue and will be corrected 
               in a future release.`
          }

     ]);
}